import React, { useState } from 'react';
import { Image } from '@applane/react-core-components';
import ReactTooltip from 'react-tooltip';
import { View } from '../../../app-components';
import {
  crossIconPng,
  squareCloseFillIcon,
  squareCloseIcon,
} from '../../../images';

const theme = {
  boxToHoldEverything: {
    padding: '2px 0px',
    width: 'inherit',
    overflowY: 'scroll',
    marginLeft: 10,
  },

  boxToHoldElement: {
    fontSize: 20,
    margin: 10,
    backgroundColor: 'white',
  },

  boxToHoldTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    fontSize: 24,
    padding: '10px 0px',
    borderBottom: '1px solid black ',
  },

  boxToHoldX: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0px 15px',
    cursor: 'pointer',
    border: '1px solid red',
    height: 20,
    width: 20,
  },

  xIconProperties: {
    width: 'inherit',
    height: 'inherit',
  },

  boxToHoldXInvisible: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0px 15px',
    visibility: 'hidden',
  },

  boxToHoldEmpty: {
    height: '90%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 20,
    color: 'grey',
  },

  boxToHoldMakerName: {
    borderTop: '1px solid black',
    borderBottom: '1px solid black',
    paddingTop: '10px',
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
  },

  boxToHoldMakerNameHover: {
    borderTop: '1px solid black',
    borderBottom: '1px solid black',
    paddingTop: '10px',
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    backgroundColor: 'rgba(236,240,241,1)',
  },
};

const generateList = (data) => {
  const listItems = data.map((item, index) => (
    <li style={theme.boxToHoldElement} key={index}>
      {item}
    </li>
  ));

  const listStyle = {
    overflowY: 'auto',
    listStyleType: 'square',
    backgroundColor: 'white',
  };

  return <ul style={listStyle}>{listItems}</ul>;
};

const generateEmptyList = () => <View style={theme.boxToHoldEmpty}>No Data Available...</View>;

const SimpleList = ({ navigation }) => {
  const { title, item } = navigation?.state?.params;
  const [hover, setHover] = useState(false);

  return (
    <>
      <ReactTooltip
        place="bottom"
        type="dark"
        effect="float"
        id="list-close-button"
      />
      <View style={theme.boxToHoldTitle}>
        <View style={theme.boxToHoldXInvisible}>
          <Image source={crossIconPng} />
        </View>
        {title}
        <div data-tip="Close" data-for="list-close-button">
          <View
            style={theme.boxToHoldX}
            onMouseOver={() => setHover(true)}
            onFocus={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            onClick={() => navigation.pop()}
          >
            <Image
              source={hover ? squareCloseFillIcon : squareCloseIcon}
              style={theme.xIconProperties}
            />
          </View>
        </div>
      </View>
      {item.length === 0 ? generateEmptyList() : generateList(item)}
    </>
  );
};

export default SimpleList;
